export default "__VITE_ASSET__Di_O3kol__"